import { render, staticRenderFns } from "./SlackRedirect.view.vue?vue&type=template&id=4c9813d7&scoped=true&"
import script from "./SlackRedirect.view.vue?vue&type=script&lang=js&"
export * from "./SlackRedirect.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9813d7",
  null
  
)

export default component.exports